import { CommonModule } from '@angular/common';
import { Component, computed, inject, OnInit, signal, Signal } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { SkeletonModule } from 'primeng/skeleton';
import { HandlersService } from 'src/app/api/api/handlers.service';
import { DialogActionType, DialogData, DialogDataActions } from 'src/app/api/model/dialogData';
import { AppResource } from 'src/app/app.resource';
import { CombinedStore } from 'src/app/core/combined.store';
import { Resource } from 'src/app/resources/resource';
import { environment } from 'src/environments/environment';
import { CANAL_VENTE_C } from '../../constants/context.constants';
import { isPartner } from '../../utils/brand-utils';

@Component({
  selector: 'app-vyv-popup',
  standalone: true,
  imports: [CommonModule, ButtonModule, SkeletonModule],
  templateUrl: './vyv-popup.component.html',
  styles: [],
})
export class VyvPopupComponent implements OnInit {
  protected resource: Resource;
  protected store = inject(CombinedStore);

  loadPhone = signal(false);

  isPartner = isPartner(environment.brand);
  CANAL_VENTE_C = CANAL_VENTE_C;
  VyvPhone = environment.brand != 'MNT' ? '04 26 31 69 72' : '09 72 72 02 02';

  constructor(
    resources: AppResource,
    public config: DynamicDialogConfig<DialogData>,
    public ref: DynamicDialogRef,
    private handlerService: HandlersService,
  ) {
    this.resource = resources['resource'];
  }

  ngOnInit(): void {
    if (!this.store.contactPhone()) {
      this.loadPhone.set(true);
      this.handlerService.apiHandlersPhoneByProductAndBrandGet().subscribe({
        next: (response) => {
          this.store.updateHandlerContactPhone(response.phone!);
        },
        error: (err) => {
          console.error('Error fetching handler phone:', err);
          // this.loadPhone.set(false);
        },
        complete: () => {
          this.loadPhone.set(false);
        },
      });
    }
  }

  //! to map correctly with the component, please use the DialogData interface
  isCustomContent: Signal<boolean> = computed(() => this.config.data?.isCustom ?? false);

  isSingleContentLine = computed(() => this.config.data?.content?.length === 1);

  displayPhone = computed(() =>
    this.isPartner && this.store.context().canalVente !== CANAL_VENTE_C ? this.VyvPhone : this.store.contactPhone(),
  );

  closePopup(): void {
    this.ref.close();
  }

  private validation(): void {
    this.ref.close(true);
  }

  executeAction(action: DialogDataActions): void {
    if (action && typeof action.action === 'function') {
      action.action();
      this.ref.close();
    } else {
      if (action?.type === DialogActionType.CANCEL) {
        this.closePopup();
      } else {
        this.validation();
      }
    }
  }
}

export const VyvPopupConfig: Partial<DynamicDialogConfig> = {
  width: '34.375rem', //550px
  modal: true,
  resizable: false,
  showHeader: false,
};
